import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Restaurant from '@material-ui/icons/Restaurant';
import LocalDining from '@material-ui/icons/LocalDining';
// core components
import GridItem from '../../components/Grid/GridItem.js';
import { getMenus as getCategoryList } from '../../store/actions/vendor/Vendor';
import Card from '../../components/Card/Card.js';
import CardHeader from '../../components/Card/CardHeader.js';
import CardIcon from '../../components/Card/CardIcon.js';
import CardFooter from '../../components/Card/CardFooter.js';

import styles from '../../assets/jss/material-dashboard-react/views/dashboardStyle.js';

const useStyles = makeStyles(styles);
function Menus(props) {
  const valueUserLoginId = localStorage.getItem('uid') || '';
  useEffect(() => {
    props.getCategoryList();
  }, []);

  const classes = useStyles();
  return (
    <GridItem xs={12} sm={6} md={3}>
      <Link
        style={{ textDecoration: 'none' }}
        to={'/vendor2/menus/vendor/' + valueUserLoginId}
      >
        <Card>
          <CardHeader color="danger" stats icon>
            <CardIcon color="danger">
              <LocalDining />
            </CardIcon>
            <p className={classes.cardCategory}>Menus</p>
            <h3 className={classes.cardTitle}>{props.menuItems.length}</h3>
          </CardHeader>
          <CardFooter stats>
            <div className={classes.stats}>
              <Restaurant />
              List of Menus
            </div>
          </CardFooter>
        </Card>
      </Link>
    </GridItem>
  );
}

const mapStateWithProps = (state) => ({
  menuItems: state.vendor.menuItems
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList())
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(Menus);
